import { render } from "./Digitize-cards.vue?vue&type=template&id=934cf38a&scoped=true"
import script from "./Digitize-cards.vue?vue&type=script&lang=js"
export * from "./Digitize-cards.vue?vue&type=script&lang=js"

import "./Digitize-cards.vue?vue&type=style&index=0&id=934cf38a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-934cf38a"]])

export default __exports__